import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RedirectToComponent } from "./redirect-to.component";
import { LibCoreSharedModule } from "lib-core-shared";

@NgModule({
  declarations: [
    RedirectToComponent
  ],
  imports: [
    CommonModule,
    LibCoreSharedModule
  ]
})
export class RedirectToModule { }